import React from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';
import logo from '../assets/img/logo-pure.png';

import { 
  // useDispatch, 
  useSelector 
} from 'react-redux';
import State from '../states/State';
// import slice from '../states/loading/slice';
// import useStyles from '../styles/styles';
import { makeStyles } from '@material-ui/core/styles';

const useCustomStyles = makeStyles(theme => ({
  backdrop: {
    display: 'flex',
    alignItems: 'center',
    justifyItems: 'center',
    flexDirection: 'column',
    zIndex: theme.zIndex.drawer + 1,
    background: '#f9f9fc'
  },
  titleLoading: {
    fontSize: '35px',
    fontFamily: 'Oswald',
    textAlign: 'center',
    fontWeight: 'normal',
    margin: '0px',
    color: '#945696',
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      fontWeight: 'normal',
    },
  },
  wrapperLogoLoading: {
    position: 'relative',
  },
  PeLogo: {
    position: 'absolute',
    width: '60px',
    left: '1px',
    top: '2px',
  }
}));

export default function PeBackdrop() {
  // const classes = useStyles();
  const classesCustom = useCustomStyles();
  const state = useSelector((state: State) => {
    const loading = state.loading
    return ({
      loading
    });
  });

  // const dispatch = useDispatch();

  // const handleClose = () => {
  //   dispatch(slice.actions.updateLoading({isOpen: false, message: 'Processing'}));
  // };

  return (
    <div>
      <Backdrop className={classesCustom.backdrop} 
        open={state.loading.isOpen} 
        // onClick={handleClose}
      >
       <div className={classesCustom.wrapperLogoLoading}>
              <CircularProgress color="primary" size={60} thickness={3}/>
              <img src={logo} alt="Logo" className={classesCustom.PeLogo}/>
        </div>
        
        <h4 className={classesCustom.titleLoading}>{state.loading.message}</h4>
      </Backdrop>
    </div>
  );
}